import { useEffect, useMemo } from "react";

import Button from "../common/Button";
import Card from "../common/Card";
import Page from "../common/Page";
import { connect, useDispatch, useSelector } from "react-redux";
import { AuthActionCreators } from "../../store/actions/auth";
import { useLocation, useNavigate } from "react-router";

const AuthAuthorize = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const dispatch = useDispatch();
  const oauthClient = useSelector((state) => state.auth?.oauth?.client);
  const authRedirectTo = useSelector((state) => state.auth?.redirectTo);

  const searchParams = useMemo(
    () => new URLSearchParams(location.search),
    [location.search]
  );
  const clientId = useMemo(() => searchParams.get("client_id"), [searchParams]);

  const onSubmit = () => {
    const redirectURI = searchParams.get("redirect_uri") || "";
    const state = searchParams.get("state") || "";
    dispatch(AuthActionCreators.oauthAuthorize(clientId, redirectURI, state));
  };

  useEffect(() => {
    if (authRedirectTo) {
      return navigate(authRedirectTo);
    }
    dispatch(AuthActionCreators.oauthGetClient(clientId));
  }, [clientId, authRedirectTo]);

  return (
    <Page>
      <Card className="max-w-xl m-auto" title={`Authorize ${oauthClient.name}`}>
        <Card.Body>
          <div className="flex">
            <div className="flex-1">
              <p>
                {oauthClient.name} would like permission to access your account.
              </p>
              {(oauthClient.readAccess || oauthClient.writeAccess) && (
                <>
                  <p className="py-2">Authorizing will grant:</p>
                  <ul className="list-disc ml-5">
                    {oauthClient.readAccess && (
                      <li>
                        <strong>Read access</strong> to your players, sites and
                        videos
                      </li>
                    )}
                    {oauthClient.writeAccess && (
                      <li>
                        <strong>Write access</strong> to your players, sites and
                        videos
                      </li>
                    )}
                  </ul>
                </>
              )}
              {(!oauthClient.readAccess || !oauthClient.writeAccess) && (
                <>
                  <p className="py-2">
                    Authorizing will <strong>not</strong> grant:
                  </p>
                  <ul className="list-disc ml-5">
                    {!oauthClient.readAccess && (
                      <li>
                        <strong>Read access</strong> to your players, sites and
                        videos
                      </li>
                    )}
                    {!oauthClient.writeAccess && (
                      <li>
                        <strong>Write access</strong> to your players, sites and
                        videos
                      </li>
                    )}
                  </ul>
                </>
              )}
            </div>
            <div className="flex-none">
              <img
                src={oauthClient.logo}
                className="ml-10"
                alt={oauthClient.name}
                width="100"
              />
            </div>
          </div>
        </Card.Body>
        <Card.Footer className="align-right">
          <Button className="inline" color="primary" onClick={onSubmit}>
            Authorize
          </Button>
        </Card.Footer>
      </Card>
      {oauthClient.verified ? (
        <p className="text-center text-gray-600 text-sm">
          This application is developed by Empower.
        </p>
      ) : (
        <p className="text-center text-gray-600 text-sm">
          This application is <strong>not</strong> developed by Empower.
        </p>
      )}
    </Page>
  );
};

export default connect()(AuthAuthorize);
